import * as React from 'react';
import '../css/input-text.sass';
import Hat, { HatType } from './Hat';
import shouldFlipBG from '../utils/should-flip-bg';

interface NonTextInputProps {
  name: string;
  value?: string;
  text?: string;
  iconPath?: string;
  additionalText?: string;
  id: string;
  ariaLabel?: string;
  label: string;
  focus?: boolean;
  unfocus?: boolean;
  readOnly?: boolean;
  isComplete?: boolean;
  hasError?: boolean;
  errors?: any;
  theme?: 'night' | 'day';
  onFocus?: any;
  onClick?: any;
  setRef?: any;
  children?: any;
  hat?: HatType[];
  disabled?: boolean;
}

interface NonTextInputState {
  flipBg: string;
}

export default function NonTextInput(props: NonTextInputProps) {
  const style: any = {};
  const { theme = 'day' } = props;
  if (props.iconPath) {
    style.paddingLeft = '40px';
  }

  const inputEl: any = React.useRef(null);

  const handleMouseDown = () => {
    if (inputEl.current) {
      inputEl.current.classList.add('using-mouse');
    }
  };

  const handleKeyDown = (e: any) => {
    if (inputEl.current) {
      if (e.keyCode === 9) {
        inputEl.current.classList.remove('using-mouse');
      }
    }
  };

  React.useEffect(() => {
    document.addEventListener('mousedown', handleMouseDown);
    document.addEventListener('keydown', handleKeyDown);
  }, [props]);

  const [state, setState] = React.useState<NonTextInputState>({
    flipBg: ''
  });

  React.useEffect(() => {
    if (props.focus && !props.unfocus && inputEl && inputEl.current) {
      inputEl.current.focus();
    }
    if (props.unfocus) {
      inputEl.current.blur();
    }
  }, [props.focus, props.unfocus]);

  React.useEffect(() => {
    if (state.flipBg === '' && shouldFlipBG(inputEl, theme)) {
      setState({
        ...state,
        flipBg: ' flipbg'
      });
    }
    if (props.setRef !== undefined) {
      props.setRef(inputEl);
    }
  }, []);

  return (
    <>
      {props.hat &&
        props.hat.length > 0 &&
        props.hat[0] &&
        props.hat[0].message && <Hat hat={props.hat} />}
      <div
        onFocus={props.onFocus}
        ref={inputEl}
        aria-expanded={props.unfocus}
        aria-controls={`uloptions${props.id}`}
        role="combobox"
        onClick={props.onClick}
        onKeyDown={(e: any) => {
          if (e.keyCode === 32 || e.keyCode === 13) {
            props.onClick();
          }
        }}
        tabIndex={0}
        className={`input-field display-field ${
          props.isComplete ? 'complete-state ' : ''
        }${props.readOnly ? ' read-only-text' : ''}${theme}${
          props.hasError ? ' error' : ''
        }
            ${props.label ? '' : ' no-label'}${state.flipBg}
            ${props.disabled ? 'disabled' : ''}`}
      >
        <div className="text">
          {!!props.label && <label htmlFor={props.id}>{props.label}</label>}
          {!!props.iconPath && (
            <div
              className="icon"
              style={{
                marginRight: '8px',
                backgroundImage: `url(${props.iconPath})`
              }}
            ></div>
          )}
          <span
            id={props.id}
            aria-label={props.ariaLabel || props.label}
            className={`input-value ${theme} ${
              props.hasError ? 'invalid' : ''
            }`}
            aria-invalid={props.hasError}
          >
            {props.text}
          </span>
          {!!props.additionalText && (
            <span className={`input-value additionalText ${theme}`}>
              {props.additionalText}
            </span>
          )}
        </div>

        {props.children}
        {props.hasError && props.errors}
      </div>
    </>
  );
}
